/**
 * A unique key used to track the latest index assigned within a group,
 * within the color mappings Map.
 */
export const ASSIGNMENT_IDX_KEY = '$___idx';
